$(() => {

    moment.locale('nl');

    new BootstrapSlider();
    new CoInsured();
    new CustomValidation();
    new DatePicker();
    new FuneralQuote();
    new Gallery();
    new InsurancePremium();
    new Navbar();
    new NumberInput();

    new Collapse().registerChangeHandlers();

    if (/msie|trident\/|edge\//i.test(window.navigator.userAgent)) {
        document.documentElement.classList.add('ie');
    }

    const alertMessage = document.querySelector('.alert');
    if (alertMessage) {
        alertMessage.scrollIntoViewIfNeeded ? alertMessage.scrollIntoViewIfNeeded() : alertMessage.scrollIntoView();
    }

});
